import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    saves: [],
    editingSave: false,
    editingFeature: false
  },
  mutations: {
    updateWorkspaceName (state, value) {
      state.saves[state.editingSave].name = value;
      console.log(state);
    },
    updateWorkspaceWidth (state, value) {
      state.saves[state.editingSave].workspace.width = value;
      console.log(state);
    },
    updateWorkspaceHeight (state, value) {
      state.saves[state.editingSave].workspace.height = value;
      console.log(state);
    },
    updateName (state, name) {
      state.saves[state.editingSave].features[state.editingFeature].name = name;
      console.log(state);
    },
    updateSizeWidth (state, width) {
      state.saves[state.editingSave].features[state.editingFeature].size.width = width;
      console.log(state);
    },
    updateSizeHeight (state, height) {
      state.saves[state.editingSave].features[state.editingFeature].size.height = height;
      console.log(state);
    },
    updatePosition (state, position) {
      state.saves[state.editingSave].features[state.editingFeature].position = position;
      console.log(state);
    },
    updatePositionLeft (state, value) {
      state.saves[state.editingSave].features[state.editingFeature].position.left = value;
      console.log(state);
    },
    updatePositionTop (state, value) {
      state.saves[state.editingSave].features[state.editingFeature].position.top = value;
      console.log(state);
    },
    updateColorBackground (state, value) {
      state.saves[state.editingSave].features[state.editingFeature].color.background = value;
      console.log(state);
    },
    updateColorBorder (state, value) {
      state.saves[state.editingSave].features[state.editingFeature].color.border = value;
      console.log(state);
    },
    addFeature (state) {
      const newIndex = state.saves[state.editingSave].features.length;
      const newFeature = {
        name: '',
        size: {
            height: null,
            width: null
        },
        position: {
            left: null,
            top: null
        },
        color: {
            background: '#ffffff',
            border: '#000000'
        }
      };
      state.saves[state.editingSave].features.push(newFeature);
      state.editingFeature = newIndex;
      console.log(state);
    },
    deleteFeature (state, index) {
      state.saves[state.editingSave].features.splice(index, 1);
      console.log(state);
    },
    copyFeature (state, index) {
      const duplicatedFeature = JSON.parse(JSON.stringify(state.saves[state.editingSave].features[index]));
      duplicatedFeature.name = `${duplicatedFeature.name} copy`;
      state.saves[state.editingSave].features.push(duplicatedFeature);
      console.log(state);
    },
    addWorkspace (state) {
      const newIndex = state.saves.length;
      const newWorkspace = {
        name: '',
        workspace: {
          height: 48,
          width: 48,
          scale: 10
        },
        features: []
      };
      state.saves.push(newWorkspace);
      state.editingSave = newIndex;
      console.log(state);
    },
    deleteWorkspace (state, index) {
      state.saves.splice(index, 1);
      console.log(state);
      console.log(JSON.stringify(state));
    },
    copyWorkspace (state, index) {
      const duplicatedWorkspace = JSON.parse(JSON.stringify(state.saves[index]));
      duplicatedWorkspace.name = `${duplicatedWorkspace.name} copy`;
      state.saves.push(duplicatedWorkspace);
      console.log(state);
    },
    saveWorkspaces (state, saves) {
      state.saves = saves;
      console.log(state);
    },
    saveEditingSave (state, index) {
      state.editingSave = index;
      console.log(state);
    },
    saveEditingFeature (state, index) {
      state.editingFeature = index;
      console.log(state);
    },
    zoomIn (state) {
      state.saves[state.editingSave].workspace.scale = state.saves[state.editingSave].workspace.scale - 1;
      console.log(state);
    },
    zoomOut (state) {
      state.saves[state.editingSave].workspace.scale = state.saves[state.editingSave].workspace.scale + 1;
      console.log(state);
    },
    clearWorkspace (state) {
      state.saves[state.editingSave].features = [];
      console.log(state);
    }
  },
  plugins: [createPersistedState()]
});